/**
 * Type-safe locale-aware route helpers. Never hardcode URLs in features/pages.
 */
import type { LocaleCode } from '@sshop/domain';

export const routes = {
  home: (locale: LocaleCode) => `/${locale}`,
  categories: (locale: LocaleCode) => `/${locale}/categories`,
  catalog: (locale: LocaleCode, slug?: string) =>
    slug ? `/${locale}/catalog/${slug}` : `/${locale}/catalog`,
  search: (locale: LocaleCode, q?: string) =>
    q && q.length > 0 ? `/${locale}/catalog?q=${encodeURIComponent(q)}` : `/${locale}/catalog`,
  product: (locale: LocaleCode, slug: string) => `/${locale}/product/${slug}`,
  compare: (locale: LocaleCode) => `/${locale}/compare`,
  cart: (locale: LocaleCode) => `/${locale}/cart`,
  favorites: (locale: LocaleCode) => `/${locale}/favorites`,
  checkout: (locale: LocaleCode) => `/${locale}/checkout`,
  orderSuccess: (locale: LocaleCode, orderId: string) => `/${locale}/checkout/success/${orderId}`,
  account: (locale: LocaleCode) => `/${locale}/account`,
  login: (locale: LocaleCode) => `/${locale}/login`,
  register: (locale: LocaleCode) => `/${locale}/register`,
  forgotPassword: (locale: LocaleCode) => `/${locale}/forgot-password`,
  resetPassword: (locale: LocaleCode, token: string) =>
    `/${locale}/reset-password/${encodeURIComponent(token)}`,
  authSocialCallback: (locale: LocaleCode) => `/${locale}/auth/social/callback`,
  about: (locale: LocaleCode) => `/${locale}/about`,
  contact: (locale: LocaleCode) => `/${locale}/contact`,
  guarantee: (locale: LocaleCode) => `/${locale}/guarantee`,
  shippingPayment: (locale: LocaleCode) => `/${locale}/shipping-payment`,
  news: (locale: LocaleCode) => `/${locale}/news`,
  newsArticle: (locale: LocaleCode, slug: string) => `/${locale}/news/${slug}`,
  privacyPolicy: (locale: LocaleCode) => `/${locale}/privacy-policy`,
  termsConditions: (locale: LocaleCode) => `/${locale}/terms-conditions`,
} as const;
